// extracted by mini-css-extract-plugin
export default {"tooltip":"b2TDsHAPd8B9LhXsjf_S","newText":"En9kWzbpoMvRB5vAz9H_","headerMargin":"HGoL7WLL3wUfr0iXgL37"};